import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core";

import useFocusTrap from "../../../../useFocusTrap.js";
import ToggleBtn from "./CustomToggle";
import { BlueButton, DullButton } from "../../../../ReusableComponents/GetButtons/GetButtons";
import "../../../../ReusableComponents/GetButtons/getButton.css"

const useStyle = makeStyles(() => ({
  backShade: {
    position: "fixed",
    zIndex: "100",
    height: "100%",
    width: "100%",
    top: "0",
    background: "#00000060",
    left: "0"
  },
  createNew_PopUp: {
    position: "fixed",
    zIndex: "100",
    left: "50%",
    top: "50%",
    height: "440px",
    width: "422px",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    border: "1px solid #00000040",
    transform: "translate(-50%,-50%)",

    "::placeholder": {
      color: "#c4c4c4"
    }
  },
  createNew_PopUp_header: {
    borderBottom: "1px solid #00000040",
    textAlign: (props) => (props.translationStyles1 ? "right" : "left"),
    fontSize: "14px",
    fontWeight: "600",
    padding: "0 18px",
    height: "50px",
    lineHeight: "50px"
  },
  createNew_PopUp_body: {
    padding: "0 18px",
    "& div": {
      display: "flex",
      flexDirection: "column",
      margin: "2px 0",
      justifyContent: "space-between"
    },
    "& label": {
      fontSize: "12px",
      fontWeight: "600",
      color: "#606060",
      display: "block",
      textAlign: (props) => (props.translationStyles1 ? "right" : "left"),
      minWidth: "100px",
      lineHeight: "28px"
    },
    "& input, & textarea": {
      display: "block",
      textAlign: (props) => (props.translationStyles1 ? "right" : "left"),
      height: "28px",
      width: "-webkit-fill-available",
      resize: "none",
      padding: "0 5px",
      fontSize: "12px",
      border: "1px solid #C4C4C4",
      borderRadius: "2px",
      "&:focus , &:focus-visible , &:hover": {
        border: "1px solid #C4C4C4",
        outline: "none"
      }
    },
    "& textarea": {
      height: "84px"
    }
  },
  createNew_PopUp_footer: {
    position: "absolute",
    bottom: "0",
    width: "100%",
    textAlign: (props) => (props.translationStyles1 ? "left" : "right"),
    background: "#F5F5F5",
    height: "50px",
    paddingTop: "5px",
    "& button": {
      margin: (props) => (props.translationStyles1 ? "0 6px !important" : null),
      fontSize: "12px",
      height: "28px",
      minWidth: "54px"
    }
  },
  select: {
    height: "30px"
  },
  errorMsg: {
    color: "red",
    fontSize: "12px",
    lineHeight: "20px",
    // marginLeft: "7px !important",
    alignSelf: "flex-start"
  },
  inputWrapper: {
    flexDirection: "column",
    width: "-webkit-fill-available"
  },
  dataObjects: {
    flex: 1,
    display: "flex"
  },
  checkLabel: {
    textAlign: "left",
    font: "normal normal normal 12px/20px Open Sans",
    letterSpacing: "0px",
    color: "#000000",
    opacity: 1
  },
  mappingWrap: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row  !important",
    justifyContent: "unset !important"
  },
  inputSpanWrap: {
    paddingLeft: (props) => (props.translationStyles1 ? "unset" : "155px"),
    paddingRight: (props) => (props.translationStyles1 ? "155px" : null),
    // justifyContent: "none",
    flexDirection: "row  !important",
    justifyContent: "unset !important",
    alignItems: "center"
  },
  yesNo: {
    paddingLeft: "10px",
    fontWeight: 600,
    paddingBottom: "4px"
  }
}));

function SaveTemplate(props) {
  const translationStyles1 =
    window?.interfaceDesigner_configs?.selectedLanguage === "ar" ||
    window?.interfaceDesigner_configs?.selectedLanguage === "ar-SA";

  const trapRef = useFocusTrap();
  const { t } = useTranslation();
  const classes = useStyle({ translationStyles1 });

  const [mappingYesNo, setMappingYesNo] = useState(true);
  const [templateDetails, setTemplateDetails] = useState({
    templateName: "",
    templateDesciption: "",
    categoryid: ""
  });
  const [templateError, setTemplateError] = useState({
    templateName: false,
    templateCategory: false,
    templateDesciption: false,
    categoryid: false
  });

  useEffect(() => {
    props.setNewTemplate((prev) => {
      return {
        ...prev,
        templateimage: props.screenshot
      };
    });
  }, []);

  useEffect(() => {
    props.setNewTemplate((prev) => {
      return {
        ...prev,
        categoryid: -3,
        templatecategory: "PAGE"
      };
    });
  }, []);

  useEffect(() => {
    if (props.templateType === "page") {
      props.setNewTemplate((prev) => {
        return {
          ...prev,
          tablestatus: 2
        };
      });
    }
  }, []);

  useEffect(() => {
    if (props.formBuffer) {
      let copyFormBuffer = JSON.parse(JSON.stringify(props.formBuffer));
      if (!mappingYesNo) {
        removeFromFormState(copyFormBuffer);
      }
      props.setNewTemplate((prev) => {
        return {
          ...prev,
          templatebuffer: JSON.stringify(mappingYesNo ? props.formBuffer : copyFormBuffer)
        };
      });
    }
  }, [props.formBuffer]);

  const getCategoryName = (value) => {
    for (let category of props.allCategories) {
      if (category.categoryid === parseInt(value)) {
        return category.categoryname;
      }
    }
  };

  const handleInput = (e, key) => {
    let regex = /^[a-zA-Z\u0621-\u064A][a-zA-Z0-9\u0621-\u064A\s]*$/u;

    if(props.templateType === "app" && key === "templateName") {
      regex = /^[a-zA-Z\u0621-\u064A][a-zA-Z0-9\u0621-\u064A]*$/u;
    }

    if (
      regex.test(e.target.value) ||
      e.target.value === "" ||
      key === "templateCategory" ||
      key === "categoryid"
    ) {
      setTemplateDetails({
        ...templateDetails,
        [key]: e.target.value,
        ["categoryName"]: key === "templateCategory" ? getCategoryName(e.target.value) : undefined
      });
      setTemplateError({
        ...templateError,
        [key]: false
      });
    }
  };

  useEffect(() => {
    props.setNewTemplate((prev) => {
      return {
        ...prev,
        templatename: "",
        description: ""
      };
    });
  }, []);

  const closeTemplatePopup = () => {
    const TemplateName = document.getElementById("newApplication_save_temp_name");
    if (TemplateName !== undefined && TemplateName !== null) TemplateName.value = "";

    const $select = document.querySelector("#newApplication_category_id");
    if ($select) {
      const text = "Select";
      const $options = Array.from($select.options);
      const optionToSelect = $options.find((item) => item.text === text);
    }

    const TemplateDesciption = document.getElementById("newApplication_save_temp_description");
    if (TemplateDesciption !== undefined && TemplateDesciption !== null) TemplateDesciption.value = "";

    props.setNewTemplate((prev) => {
      return {
        ...prev,
        templatename: "",
        description: ""
      };
    });

    props.templateType === "app"
      ? props.setSaveAppTemplate_popup("closed")
      : props.templateType === "page"
      ? props.setSavePageTemplate_popup("closed")
      : props.setSaveSubformTemplate_popup("closed");
  };

  const removeFromFormState = (formState) => {
    if (formState.children) {
      for (let i = 0; i < formState.children.length; i++) {
        if (formState.children[i]?.dataclass) {
          delete formState.children[i].dataclass;
          delete formState.children[i].datamapPercision;
          delete formState.children[i].datamapVariableLength;
          delete formState.children[i].datamapVariableType;
          delete formState.children[i].datamapid;
          delete formState.children[i].style.MappingId;
          delete formState.children[i].style.Mapping;
          // formState.children[i].style.Label = formState.children[i].id;

          if((formState.children[i].elem_type === "advancelistView" ||
            formState.children[i].elem_type === "advancelistview" ||
            formState.children[i].elem_type === "listview" ||
            formState.children[i].elem_type === "table") &&
            formState?.children?.[i]?.columnList?.length
          ) {
            formState.children[i].columnList.forEach(col => {
              delete col.style["complexFieldName"];
              delete col.style["associatedControlId"];
              delete col.style["complexFieldType"];
              delete col.style["complexFieldVariableLength"];
              delete col.style["complexFieldVariablePrecision"];
            })
          }
        }
        if (formState.children[i]?.subform && formState.children[i].elem_type === "button") {
          removeFromFormState(formState.children[i].subform);
        } else if (
          formState.children[i]?.listviewFrameLayoutJson &&
          (formState.children[i].elem_type === "advancelistView" ||
            formState.children[i].elem_type === "advancelistview" ||
            formState.children[i].elem_type === "listview")
        ) {
          removeFromFormState(formState.children[i].listviewFrameLayoutJson);
        } else {
          removeFromFormState(formState.children[i]);
        }
      }
    } else {
      return;
    }
  };

  function checkTemplateDetails() {
    let obj = {
      templateName: false,
      templateDesciption: false,
      categoryid: false
    };
    if (templateDetails.templateName === "") {
      obj.templateName = true;
    }
    if (templateDetails.templateDesciption === "") {
      obj.templateDesciption = true;
    }
    if (templateDetails.templateCategory === "") {
      obj.templateCategory = true;
    }
    if (templateDetails.categoryid === "") {
      obj.categoryid = true;
    }
    let result = hasEmptyValue(obj);
    setTemplateError({ ...obj });
    return result;
  }

  function hasEmptyValue(obj) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] === true) {
        return true;
      }
    }
    return false;
  }

  const submitApplication = (e) => {
    e.preventDefault();
    let templateResult = checkTemplateDetails();
    if (templateResult) return;
    let dateNow = new Date();
    let copyFormBuffer = JSON.parse(JSON.stringify(props.formBuffer));

    if (!mappingYesNo) {
      removeFromFormState(copyFormBuffer);
    }

    try {
      props.setNewTemplate((prev) => {
        return {
          ...prev,
          createddatetime: dateNow,
          createdby: "Shivam",
          lastAccessedby: "Shivam",
          lastModifiedtime: dateNow,
          usageCount: 0,
          lastAccessedtime: dateNow,
          lastModifiedby: "Shivam",
          templatebuffer:
            props.templateType === "app"
              ? props.activePane?.applicationId !== undefined
                ? props.activePane?.applicationId?.toString()
                : mappingYesNo
                ? JSON.stringify(props.formBuffer)
                : JSON.stringify(copyFormBuffer)
              : mappingYesNo
              ? JSON.stringify(props.formBuffer)
              : JSON.stringify(copyFormBuffer)
        };
      });

      if (props.templateType === "app") {
        props.createNewTemplate("app", templateDetails);
      } else if (props.templateType === "page") {
        props.createNewTemplate(
          mappingYesNo ? JSON.stringify(props.formBuffer) : JSON.stringify(copyFormBuffer),
          templateDetails
        );
      } else if (props.templateType === "form") {
        props.createNewTemplate(templateDetails);
      }
    } catch (err) {
      console.log("Error:: ", err);
    }
  };

  useEffect(() => {
    if (document.getElementById("saveTemplateId")) {
      document.getElementById("saveTemplateId").focus();
    }
  }, []);

  function handleEscapeKey(e) {
    e.stopPropagation();
    if (e.code === "Escape") {
      closeTemplatePopup();
    }
  }

  return (
    <>
      <div className={classes.backShade}></div>

      <div
        ref={trapRef}
        tabIndex="0"
        onKeyDown={(e) => handleEscapeKey(e)}
        onClick={(e) => e.stopPropagation()}
        className={`${classes.createNew_PopUp} savetemplatePop_up`}
        role="region"
        aria-label="Save Section"
        id="saveTemplateId"
      >
        <div className={classes.createNew_PopUp_header}>
          {props.templateType === "app"
            ? t("Save Application as Template")
            : props.activeSubform
            ? t("Save Subform as Template")
            : t("Save Page as Template")}
        </div>

        <div className={classes.createNew_PopUp_body}>
          <div>
            <label>
              {t("Template Name")} <b style={{ color: "#D53D3D" }}>*</b>
            </label>

            <div className={classes.inputWrapper}>
              <input
                aria-label={"Template Name"}
                id={"newApplication_save_temp_name"}
                placeholder={t("placeholderMsg")}
                className="popUpInputBox"
                autoComplete="off"
                value={templateDetails.templateName}
                onChange={(e) => handleInput(e, "templateName")}
                name="templatename"
                maxLength={50}
              />
              {templateError.templateName ? <div className={classes.errorMsg}>{t("Empty-Field")}</div> : null}
            </div>
          </div>

          <div>
            <label>
              {t("Category")} <b style={{ color: "#D53D3D" }}>*</b>
            </label>

            <div className={classes.inputWrapper}>
              <select
                className={classes.select}
                name="categoryid"
                id="newApplication_category_id"
                onChange={(e) => {
                  handleInput(e, "categoryid");
                }}
              >
                {props.newTemplate?.templatename?.length === 0 && (
                  <option name="category" value="" disabled selected>
                    {t("Select")}
                  </option>
                )}

                {props.newTemplate?.templatename?.length > 0 && (
                  <option name="" value="" disabled selected>
                    {t("Select")}
                  </option>
                )}

                {props.allCategories.map((category, count) => {
                  return (
                    <option id={count} value={parseInt(category.categoryid)} name="category" key={category.categoryid}>
                      {category.categoryname}
                    </option>
                  );
                })}
              </select>

              {templateError.categoryid ? <div className={classes.errorMsg}>{t("Empty-Field")}</div> : null}
            </div>
          </div>

          <div className={classes.mappingWrap}>
            <label for="Mapping">{t("Keep_Data_Objects_Mapping")} </label>

            <div className={classes.inputSpanWrap}>
              <ToggleBtn
                handleToggle={() => setMappingYesNo(!mappingYesNo)}
                widthMin={true}
                toggleState={mappingYesNo + ""}
              />
              <span className={classes.yesNo}>{mappingYesNo ? t("Yes") : t("No")}</span>
            </div>
          </div>

          <div>
            <label>
              {t("Template Description")} <b style={{ color: "#D53D3D" }}>*</b>
            </label>

            <div className={classes.inputWrapper}>
              <textarea
                aria-label="Template Description"
                id={"newApplication_save_temp_description"}
                placeholder={t("placeholderMsg")}
                className="popUpInputBox"
                value={templateDetails.templateDesciption}
                onChange={(e) => handleInput(e, "templateDesciption")}
                name="description"
                maxLength={255}
              />
              {templateError.templateDesciption ? <div className={classes.errorMsg}>{t("Empty-Field")}</div> : null}
            </div>
          </div>
        </div>

        <div className={classes.createNew_PopUp_footer}>
          {
            <>
              <DullButton className="dull-button" onClick={() => closeTemplatePopup()}>{t("Cancel")}</DullButton>
              <BlueButton className="blue-button" onClick={(e) => submitApplication(e)}>{t("Create")}</BlueButton>
            </>
          }
        </div>
      </div>
    </>
  );
}

export default SaveTemplate;
